import { FC, useEffect, useRef } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { PopupStore, AlertPopup } from '@gem/popups';

import Tasks from 'APP/Tasks';

interface IAutoplayingLoopAudioProps {
  permissionText: string;
  src: string;
  volume?: number;
}

export const AutoplayingLoopAudio: FC<IAutoplayingLoopAudioProps> = ({
  permissionText,
  src,
  volume = 1,
}) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const alertPopup = useRef<PopupStore>();
  const { t } = useTranslation();

  useEffect(() => {
    let isMounted = true;
    const audio = audioRef.current;

    if (audio) {
      audio.play().catch(async () => {
        if (isMounted) {
          alertPopup.current = Tasks.app.openPopup(AlertPopup, {
            params: { text: permissionText, primaryText: t('common_ok') },
            onClose: () => audio?.play(),
          });
        }
      });

      audio.volume = volume;
    }

    return () => {
      isMounted = false;

      if (audio) {
        audio.volume = 1;
        audio.pause();
        audio.src = '';
        audio.load();
      }

      alertPopup.current?.close();
    };
  }, []);

  return (
    <audio
      ref={audioRef}
      src={src}
      loop
    />
  );
};
